import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import Notification from "../../../../elements/notification/Notification";
import MaterialPagination from "../../../../styles/materialPagination";
import WalletPaymentList from "./WalletPaymentList";
import ItemsPerPageSelect from "../../../../elements/filter/ItemsPerPageSelect";
import TransactionFilter from "../../../../elements/transactions/TransactionFilter";
import FilterAppliedList from "../../../../elements/filter/FilterAppliedList";
import { parseAxiosError } from "../../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../../utils/consts";
import { itemsPerPageValue } from "../../../../../utils/ItemsPerPageValue";

const WalletPaymentsContainer = ({ match }) => {
  const [payments, setPayments] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "payments", false, true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "status": checkFilterItem(history, "status", null),
    "id": checkFilterItem(history, "id", null),
    "referenceId": checkFilterItem(history, "referenceId", null),
    "exchangeId": checkFilterItem(history, "exchangeId", null),
    "processedAmount[gte]": checkFilterItem(history, "processedAmount[gte]", null, true),
    "processedAmount[lte]": checkFilterItem(history, "processedAmount[lte]", null, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "processingId": checkFilterItem(history, "processingId", null),
    "note": checkFilterItem(history, "note", null),
    "resourceType": checkFilterItem(history, "resourceType", null),
    "status.value": checkFilterItem(history, "status.value", null),
    "paymentSystem.name": checkFilterItem(history, "paymentSystem.name", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null),
    "paymentType": checkFilterItem(history, "paymentType", null),
    "transactionType": checkFilterItem(history, "transactionType", null),
    "relatedReferenceId": checkFilterItem(history, "relatedReferenceId", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchPayments = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/get-transaction-native" + filterUrl + "&custodialWalletId=" + match.params.id + '&resourceType=payment', userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setPayments(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchPayments();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <TransactionFilter
          filterData={filterData}
          setFilterData={setFilterData}
          userId={match.params.id}
          direction="payments"
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <WalletPaymentList payments={payments} />
      {totalPageCount > 1  &&
      <MaterialPagination
        count={totalPageCount}
        shape="rounded"
        page={filterData.page}
        onChange={(event, page) => onChangePage(event, page)}
      />}
    </>
  );
};

export default WalletPaymentsContainer;
